import Vue from 'vue';
import Vue18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui中文包
import elementIdLocale from 'element-ui/lib/locale/lang/id'// element-ui中文包
import ZHCN from './lang/zh-cn';
import ENUS from './lang/en-us';
import ID from './lang/id';

//使用引入
Vue.use(Vue18n);

//定义标识符
const i18n = new Vue18n({
    locale: 'en_US',    // 语言标识
    messages: {
        'zh_CN': {...ZHCN, ...elementZhLocale},  // 中文语言包
        'en_US': {...ENUS, ...elementEnLocale},    // 英文语言包
        'id':{...ID,...elementIdLocale} //印尼语言包
    }
});
locale.i18n((key, value) => i18n.t(key, value))
export default i18n;